module.exports = __webpack_public_path__ + "img/Invoices.3c4f811b.png";